/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerContextQueryResponse, VistaControllerContextPathParams, VistaControllerContext400, VistaControllerContext401, VistaControllerContext403, VistaControllerContext404 } from "../../models/changeOrdersController/VistaControllerContext";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { vistaControllerContext } from "../../clients/change-ordersService/vistaControllerContext";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const vistaControllerContextQueryKey = (id: VistaControllerContextPathParams["id"]) => [{
  url: '/api/v1/potential-change-orders/:id/vista',
  params: {
    id: id
  }
}] as const;
export type VistaControllerContextQueryKey = ReturnType<typeof vistaControllerContextQueryKey>;
export function vistaControllerContextQueryOptions(id: VistaControllerContextPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = vistaControllerContextQueryKey(id);
  return queryOptions<VistaControllerContextQueryResponse, ResponseErrorConfig<VistaControllerContext400 | VistaControllerContext401 | VistaControllerContext403 | VistaControllerContext404>, VistaControllerContextQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return vistaControllerContext(id, config);
    }
  });
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista}
 */
export function useVistaControllerContext<TData = VistaControllerContextQueryResponse, TQueryData = VistaControllerContextQueryResponse, TQueryKey extends QueryKey = VistaControllerContextQueryKey>(id: VistaControllerContextPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<VistaControllerContextQueryResponse, ResponseErrorConfig<VistaControllerContext400 | VistaControllerContext401 | VistaControllerContext403 | VistaControllerContext404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? vistaControllerContextQueryKey(id);
  const query = useQuery({
    ...vistaControllerContextQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<VistaControllerContext400 | VistaControllerContext401 | VistaControllerContext403 | VistaControllerContext404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}